<template>
  <div class="auth-code-page__inputs"
       id="auth-code-page__inputs"
       :class="{'auth-code-page__inputs-error' : error}"
  >

    <input
        v-for="(item, index) in arrayInputs"
        type="number"
        maxlength="1"
        max="1"
        inputmode="numeric"
        :ref="`inputCode_${index}`"
        :key="`input-code_${index}`"
        v-model="arrayInputs[index]"
        @input="input(index)"
    >

  </div>
</template>

<script>
export default {
  data: () => ({
    arrayInputs: ['','','','']
  }),
  mounted() {

  },
  props: {
    error: {
      default: false
    },
    clear: {
      default: false
    }
  },
  watch: {
    clear(val) {
      if(val) {
        this.clearInputs()
      }
    }
  },
  methods: {
    input(index) {
      this.arrayInputs[index] = event.target.value;
      if(event.target.value.length > 0) {
        if(this.$refs[`inputCode_${index + 1}`]) this.$refs[`inputCode_${index + 1}`][0].focus();
      }
      this.setCar();
    },
    setInput(input) {
      input.focus()
      input.type = 'text'
      input.selectionStart = input.value.length;
      input.type = 'number'
    },
    setCar() {
      let str = this.arrayInputs.join('')
      if(str.length === 4) {
        this.$emit('changeButton', {
          status: true,
          value: Number(str)
        })
      } else {
        this.$emit('changeButton', {
          status: false
        })
      }
    },
    clearInputs() {
      this.arrayInputs = ['','','','']

      this.$emit('clearEnd')
    }
  }
}
</script>

<style lang="less">

@import '~/assets/fonts/montserrat/Montserrat-Bold.less';

.auth-code-page__title {
  color: #FFFFFF;
  font-size: 19px;
  font-family: 'Montserrat-Bold';
}

.auth-code-page__inputs {
  display: flex;
  align-items: center;
  margin-top: 24px;
}

.auth-code-page__inputs input {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.15);
  outline: none;
  border: none;
  margin-right: 8px;
  font-size: 24px;
  padding-left: 20px;
  color: #B8B4C0;
}

.auth-code-page__inputs-error input {
  border: 1px solid #af3030;
}

#auth-code-page__inputs input::-webkit-outer-spin-button,
#auth-code-page__inputs input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
#auth-code-page__inputs input[type=number] {
  -moz-appearance: textfield;
}
</style>